import React from 'react';

import { useHistory } from "react-router-dom";
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import DescriptionIcon from '@material-ui/icons/Description';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import PeopleIcon from '@material-ui/icons/People';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';

// import CallReceivedIcon from '@material-ui/icons/CallReceived';
// import LoopIcon from '@material-ui/icons/Loop';
// import CallMadeIcon from '@material-ui/icons/CallMade';
// import ListSubheader from '@material-ui/core/ListSubheader';

import { PAGE_MENU, PAGE_ROUTE } from '../../constants';
import API from '../../services/api';
import Dashboard from '../dashboard';

export default function DashboardAdmin({ children, ...props }) {
  const history = useHistory();
  const profile_id = Number(API.encryptedSessionStorage.getItem('profile_id', API.encryptedSessionStorage.getTokenData().uid));

  function handleClick(event, route) {
    event.preventDefault();
    API.refreshToken();
    history.push(route);
  }

  const drawer = (
    <>
      { profile_id === 1 &&
        <>
          <ListItem button onClick={(e) => handleClick(e, PAGE_ROUTE.SCHOOLS)} >
            <ListItemIcon><AccountBalanceIcon /></ListItemIcon>
            <ListItemText primary={PAGE_MENU.SCHOOLS} />
          </ListItem>
          <ListItem button onClick={(e) => handleClick(e, PAGE_ROUTE.USERS)} >
            <ListItemIcon><PeopleIcon /></ListItemIcon>
            <ListItemText primary={PAGE_MENU.USERS} />
          </ListItem>
        </>
      }
      <ListItem button onClick={(e) => handleClick(e, PAGE_ROUTE.OPERATIONS)} >
        <ListItemIcon><AttachMoneyIcon /></ListItemIcon>
        <ListItemText primary={PAGE_MENU.OPERATIONS} />
      </ListItem>
      <ListItem button onClick={(e) => handleClick(e, PAGE_ROUTE.VALIDACOES)} >
        <ListItemIcon><VerifiedUserIcon /></ListItemIcon>
        <ListItemText primary={PAGE_MENU.VALIDACOES} />
      </ListItem>
      <Divider />
      {/* <ListSubheader inset>Histórico</ListSubheader> */}
      { profile_id === 1 &&
      <>
      <ListItem button onClick={() => history.push(PAGE_ROUTE.LOGS)} >
        <ListItemIcon><DescriptionIcon /></ListItemIcon>
        <ListItemText primary={PAGE_MENU.LOGS} />
      </ListItem>
      </>
      }
      {/*
        <ListItem button onClick={() => history.push(PAGE_ROUTE.DEPOSITOS)} >
          <ListItemIcon><CallMadeIcon /></ListItemIcon>
          <ListItemText primary={PAGE_MENU.DEPOSITOS} />
        </ListItem>
        <ListItem button onClick={() => history.push(PAGE_ROUTE.SAQUES)} >
          <ListItemIcon><CallReceivedIcon /></ListItemIcon>
          <ListItemText primary={PAGE_MENU.SAQUES} />
        </ListItem>
        <ListItem button onClick={() => history.push(PAGE_ROUTE.TRANSFERENCIAS)} >
          <ListItemIcon><LoopIcon /></ListItemIcon>
          <ListItemText primary={PAGE_MENU.TRANSFERENCIAS} />
        </ListItem>
        */}
    </>
  );

  return (
    <Dashboard drawer={drawer} props={props}>{children}</Dashboard>
  );
}
